import { BaseModel } from "./BaseModel";

export class IntegrationSchema extends BaseModel {
  schema = "/integrationSchema";
  constructor(params) {
    return super(params, "/integrationSchema");
  }
}
